// api/subscribeFilesPaginated.ts
import { Int } from "@adornis/baseql/baseqlTypes.js";
import { baseqlMetaData } from "@adornis/baseql/metadata/metaDataStore.js";
import { registerSubscription } from "@adornis/baseql/metadata/register.js";
import { getRawCollection } from "@adornis/baseql/server/collections.js";
import "@adornis/file-utils/db/files.js";
import { from } from "rxjs";
import { FileFilter } from "../db/FileFilter.js";
import { FileListItem } from "../db/FileListItem.js";
var subscribeFilesPaginatedFilteredResolver = (skip, limit, filter) => {
  return (gqlFields) => {
    return from(
      new Promise(async (resolve, reject) => {
        const resolvedFileClasses = (filter?.fileClassNames ?? []).map((fileClassName) => {
          return baseqlMetaData.entities.resolveNode(fileClassName).type();
        });
        if (!resolvedFileClasses[0])
          return resolve([]);
        const rawCollection = await getRawCollection(resolvedFileClasses[0]._collectionName);
        resolvedFileClasses.splice(0, 1);
        const result = await rawCollection.aggregate(filter?.getFileListAggregation({ skip, limit, gqlFields, resolvedFileClasses })).toArray();
        return resolve(result);
      })
    );
  };
};
var subscribeFilesPaginatedFiltered = registerSubscription({
  type: () => [FileListItem],
  operationName: "subscribeFilesPaginatedFiltered",
  resolve: subscribeFilesPaginatedFilteredResolver,
  params: [
    { type: () => Int, name: "skip" },
    { type: () => Int, name: "limit" },
    { type: () => FileFilter, name: "filter" }
  ]
});
export {
  subscribeFilesPaginatedFiltered
};
